import { Link } from "react-router-dom";

export function SectionTitle({
  eyebrow,
  title,
  desc,
  to,
  linkText,
}: {
  eyebrow?: string;
  title: string;
  desc?: string;
  to?: string;
  linkText?: string;
}) {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
      <div>
        {eyebrow && (
          <p className="mb-1 text-xs font-bold uppercase tracking-widest text-accent-600">
            {eyebrow}
          </p>
        )}
        <h2 className="font-heading text-2xl text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {desc && (
          <p className="mt-2 max-w-xl text-sm leading-6 text-foreground-600">
            {desc}
          </p>
        )}
      </div>
      {to && (
        <Link
          to={to}
          className="flex shrink-0 items-center gap-1 rounded-full border border-primary-300 bg-primary-100/60 px-4 py-2 text-sm font-medium text-primary-800 transition hover:bg-primary-500 hover:text-background-50 whitespace-nowrap"
        >
          {linkText || "查看全部"}
          <i className="ri-arrow-right-line text-sm"></i>
        </Link>
      )}
    </div>
  );
}